import { types, actions } from './requests'
export const CREATEJOB_TYPES = {
    ...types('CREATEJOB'),
}
export const CREATEJOB_ACTIONS = {
    ...actions('CREATEJOB'),
}
